<template>
  <div>
    <CategoryConsumptionPage
      :consumption_category_id="3"
      :showFuelGasAndDieselChart="true"
      :colors="{ primary: '#73AB6B', secondary: '#99AB96' }"
      titleCompare="Gas consumption compare to Fuel & Diesel"
      :consumption_category="{ name: 'gas', unit: { text: 'Gal.' } }"
    >
    </CategoryConsumptionPage>
  </div>
</template>

<script>
import CategoryConsumptionPage from '@/components/consumption/CategoryConsumptionPage';
export default {
  name: 'GasConsumptionPage',
  components: { CategoryConsumptionPage },
};
</script>

<style scoped></style>
